import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { renderTransmissionGroupsTable } from '~/components/recruiting/transmission-groups-table';
import { html, LpButton, LpPageHeader } from '~/design-system';
export class adminTransmissionGroups_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminTransmissionGroups-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            groups: ko.observableArray([]),
            onClickCreate: function () { self.caller.createGroup(); },
            onClickEdit: function (row) { self.caller.editGroup(row.id); },
            onClickBack: function () { self.caller.backToTransmissions(); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: 'Transmission Groups',
            description: 'Manage transmission scheduling groups.',
            icon: 'stack',
            actions: html `
                    ${LpButton({
                label: 'Back',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Create Group',
                prefixIcon: 'plus',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickCreate',
                },
            })}
                `,
        })}

            <div class="list-page-module transmission-groups-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderTransmissionGroupsTable()}
                </div>
            </div>
        `;
    }
    /**
     * Apply transmission group rows returned by the API to the view model.
     *
     * @param groups Array<any>
     * @return void
     */
    setGroups(groups) {
        this.getTemplateViewModel().groups(groups || []);
    }
}
